<div class="modal-header">
    <div class="title">
        <h2 class="modal-title" *ngIf="!this.role">Modifier l’utilisateur</h2>
        <h2 class="modal-title" *ngIf="this.role === 'Provider'">Modifier le fournisseur</h2>
        <h2 class="modal-title" *ngIf="this.role === 'Shop'">Modifier la boutique</h2>
        <h4 class="modal-title" style="text-transform: uppercase;">{{ this.userInfos.fullName }} </h4>
        <h6>
            <span *ngIf="this.userInfos.isActive !== true" style="color: #dd6666;">Compte désactivé</span>
            <span *ngIf="this.userInfos.isActive === true" style="color: #00cb4c;">Compte actif</span>
        </h6>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex flex-column ">
    <div class="info-modify">
        <div class="container">
            <!-- Fields -->
            <div class="row">
                <div class="col">
                    <label for="nom" class="form-label required">Nom</label>
                    <input type="text" class="form-control" id="nom" [(ngModel)]="this.userInfos.lastName">
                </div>

                <div class="col">
                    <label for="prenom" class="form-label required">Prénom</label>
                    <input type="text" class="form-control" id="prenom" [(ngModel)]="this.userInfos.firstName">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="email" class="form-label required">Email</label>
                    <input type="email" class="form-control" id="email" [(ngModel)]="this.newEmail">
                </div>
                <div class="col">
                    <label for="tel" class="form-label required">N° téléphone</label>
                    <input type="text" class="form-control" id="tel" [(ngModel)]="this.userInfos.phone">
                </div>
            </div>

            <div class="w-100"></div>
            <div class="row">
                <div class="col">
                    <label for="org" class="form-label required">Société</label>
                    <input *ngIf="this.role === 'Provider'" type="text" class="form-control" id="org"
                        [(ngModel)]="this.userInfos.providerName">
                    <input *ngIf="this.role === 'Shop'" type="text" class="form-control" id="org"
                        [(ngModel)]="this.userInfos.shopName">
                </div>
                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="subDomainName" class="form-label required">Nom de sous domaine</label>
                    <input type="text" class="form-control" id="subDomainName"
                    [(ngModel)]="this.userInfos.subDomainName">
                </div>

                <div class="w-100" *ngIf="this.role === 'Shop'"></div>

                <div class="col">
                    <label class="form-label">Logo</label>
                    <input #imageInput type="file" ng2FileSelect accept="image/*"
                        class="form-control input-logo" (change)="processImage($event)">
                    <label id="isNotValidImage" style="color: #D80000; display: none;">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        L'image doit être inférieur à 5 Mo
                    </label>
                    <label id="isValidImage" style="color: #4DCC5E; display: none;">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Téléchargé
                    </label>
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="description" class="form-label">Description</label>
                    <textarea type="text" class="form-control" id="description"
                        [(ngModel)]="this?.userInfos.description"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 d-flex flex-column modify-block">
        <button class="modify mb-4" (click)="saveModify()">
            Sauvegarder les modifications
        </button>
    </div>

    <!-- BLOCK ADDRESS -->
    <h2 class="modal-title text-center my-3">Modifier l'adresse </h2>
    <!-- Adresse -->
    <div class="row mx-1">
        <!-- street -->
        <div class="col">
            <label for="street" class="form-label required">Rue</label>
            <input *ngIf="this.role === 'Provider'" type="text" class="form-control" id="street"
                [(ngModel)]="this.userInfos.adressStreet" required>
            <input *ngIf="this.role === 'Shop'" type="text" class="form-control" id="street"
                [(ngModel)]="this.userInfos.shopAddress" required>
        </div>
        <!-- city -->
        <div class="col">
            <label for="city" class="form-label required">Ville</label>
            <input *ngIf="this.role === 'Provider'" type="text" class="form-control" id="city"
                [(ngModel)]="this.userInfos.adressCity" required>
            <input *ngIf="this.role === 'Shop'" type="text" class="form-control" id="city"
                [(ngModel)]="this.userInfos.shopCity" required>
        </div>
    </div>
    <div class="row mx-1">
        <!-- zip code -->
        <div class="col">
            <label for="postalCode" class="form-label required">Code postale</label>
            <input *ngIf="this.role === 'Provider'" type="text" class="form-control" id="postalCode"
                [(ngModel)]="this.userInfos.adressPostalCode" required>
            <input *ngIf="this.role === 'Shop'" type="text" class="form-control" id="postalCode"
                [(ngModel)]="this.userInfos.shopPostalCode" required>
        </div>
        <!-- country -->
        <div class="col">
            <label for="country" class="form-label required">Pays</label>
            <input *ngIf="this.role === 'Provider'" type="text" class="form-control" id="country"
                [(ngModel)]="this.userInfos.adressCountry" required>
            <input *ngIf="this.role === 'Shop'" type="text" class="form-control" id="country"
                [(ngModel)]="this.userInfos.shopCountry" required>
        </div>
    </div>
    <div class="col-sm-12 d-flex flex-column modify-block">
        <button class="modify mb-4" (click)="saveModifyAddress()">
            Sauvegarder les modifications
        </button>
    </div>
</div>